module.exports = __webpack_public_path__ + "static/media/LevelAlpha.22763c27.png";